import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Mensen',
    financial_metrics: 'Financiële statistieken',
    onboarding_and_quality: 'Onboarding & Kwaliteit',
    subscriptions: 'Huidige abonnementen',
    payments: 'Betalingen',
    last_invoices: 'Laatste facturen',
  },
  fields: {
    google_profile: 'Google-profiel',
    owner_name: 'Naam eigenaar',
    owner_phone_number: 'Telefoon eigenaar',
    company_phone_number: 'Telefoon restaurant',
    address: 'Adres',
    onboarding_manager: 'Onboarding manager',
    sales_manager: 'Salesmanager',
    last_30_days_sales: 'Omzet laatste 30 dagen',
    lifetime_sales: 'Totale omzet ooit',
    monthly_sales_other_platforms: 'Omzet bezorgapps',
    delivery_app_sales_at_go_live: 'Omzet bezorgapps op go-livedatum',
    last_payout: 'Laatste uitbetaling',
    potential_tier: 'Potentiële score',
    current_tier: 'IST-score',
    signed_at: 'Sluitingsdatum',
    live_from: 'Go-livedatum',
    onboarding_quality_score: 'Go-live kwaliteitsscore',
    is_google_business_available: 'Google Business beschikbaar',
    is_smart_pricing_configured: 'Goedkopere prijzen dan Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Promofolder verzonden',
    is_menu_fully_configured: 'Alle menu-items beschikbaar',
    has_offers_on_competitor_platforms:
      'Heeft het restaurant aanbiedingen op Wolt, Uber, Lieferando (behalve gratis bezorging)?',
    is_instagram_story_shared: 'Instagram-story gedeeld met eigenaar',
    is_order_system_connected_to_website: 'Foodamigos-website gekoppeld OF bestelknop eigen website toegevoegd',
    delivery_mode: 'Bezorgers',
    has_storefront: '{{provider}}-website',
    screening_date: 'Screeningdatum',
  },
  setup_fee: {
    title: 'Implementatiekosten',
    status: {
      [InvoiceStatus.Paid]: 'Betaald',
      [InvoiceStatus.Pending]: 'In afwachting',
      [InvoiceStatus.Processing]: 'Wordt verwerkt',
      [InvoiceStatus.Refunded]: 'Terugbetaald',
      [InvoiceStatus.PartiallyRefunded]: 'Gedeeltelijk terugbetaald',
      [InvoiceStatus.Failed]: 'Mislukt',
    },
  },
  labels: {
    yes: 'Ja',
    no: 'Nee',
    month: 'Maand',
    recorded_on: 'Vastgelegd op {{date}}',
  },
  delivery_app_sales_correction: {
    title: 'Omzet bezorgapps bij go-live corrigeren',
    description:
      'Corrigeer hier alleen een typefout. Dit is het maandbedrag dat onboarding bij de go-live van het restaurant heeft vastgelegd, en de rapportage vergelijkt het met dat van sales. De wijziging wordt vastgelegd.',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Actief',
    [CompanyOperationalStatus.Paused]: 'Gepauzeerd',
    [CompanyOperationalStatus.Suspended]: 'Opgezegd',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standaard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Maandelijks',
    [SubscriptionTerm.Annual]: 'Jaarlijks',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Eigen bezorgers',
    [DeliveryMode.External]: '{{provider}} bezorgers',
  },
  buttons: {
    view_details: 'Details bekijken',
    open: 'Openen',
    correct: 'Corrigeren',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    delivery_app_sales_corrected: 'Omzet bezorgapps gecorrigeerd',
    failed_to_correct_delivery_app_sales: 'Omzet bezorgapps kon niet worden gecorrigeerd',
  },
};
